import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getApiErrorMessage = (error, fallback = "Não foi possível concluir a ação. Tente novamente.") => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }

  if (error?.code === "ERR_NETWORK" || !error?.response) {
    return "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.";
  }

  const status = error.response.status;
  if (status === 401) {
    return "Sua sessão expirou. Entre novamente para continuar.";
  }
  if (status === 403) {
    return "Você não tem permissão para acessar essa informação.";
  }
  if (status === 404) {
    return "Não encontramos esse registro. Atualize a página e tente novamente.";
  }
  if (status >= 500) {
    return "O servidor encontrou uma falha temporária. Tente novamente em alguns instantes.";
  }

  return fallback;
};

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    error.friendlyMessage = getApiErrorMessage(error);
    if (!error.response) {
      error.response = { data: { detail: error.friendlyMessage } };
    } else if (!error.response.data?.detail) {
      error.response.data = {
        ...(error.response.data || {}),
        detail: error.friendlyMessage,
      };
    }
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
